import React from 'react';

import TalentFinderList from './List/PositiontFinderList';
import styles from './position-finder-detail.module.scss';

const PositionFinderDetail = (props) => {
  const { page, limit, totalData } = props;
  const fromResult = (page - 1) * limit + 1;
  const toResults = (page - 1) * limit + limit;
  return (
    <div className={styles.detail_section} data-testid="talent-finder-detail">
      <TalentFinderList totalResult={totalData} fromResult={fromResult} toResults={toResults} {...props} />
    </div>
  );
};

export default PositionFinderDetail;
